import { render, staticRenderFns } from "./posNotVisited.vue?vue&type=template&id=24c74c2e&"
import script from "./posNotVisited.vue?vue&type=script&lang=js&"
export * from "./posNotVisited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports